export default function Puzzle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32.998"
      height="34.097"
      viewBox="0 0 32.998 34.097"
    >
      <g id="puzzle_2_" data-name="puzzle (2)" transform="translate(-8.25)">
        <g
          id="Group_10871"
          data-name="Group 10871"
          transform="translate(26.517 0)"
        >
          <g id="Group_10870" data-name="Group 10870">
            <g id="Group_10869" data-name="Group 10869">
              <path
                id="Path_2182"
                data-name="Path 2182"
                d="M290.138,17.67a2.67,2.67,0,0,1-2.043-.953,2.746,2.746,0,0,1-.645-1.986H283.21a.666.666,0,0,1-.666-.666V9.574a.666.666,0,0,1,.786-.655l.04.007a1.369,1.369,0,1,0,0-2.693l-.04.007a.666.666,0,0,1-.786-.655V.666A.666.666,0,0,1,283.21,0h11.048a3.021,3.021,0,0,1,3.018,3.018V14.065a.666.666,0,0,1-.666.666h-3.782a2.7,2.7,0,0,1-2.65,2.939ZM283.876,13.4h4.358a.666.666,0,0,1,.655.786l-.091.5a1.419,1.419,0,0,0,.314,1.175,1.328,1.328,0,0,0,1.045.482,1.369,1.369,0,0,0,1.325-1.615l-.1-.538a.666.666,0,0,1,.655-.786h3.9V3.018a1.688,1.688,0,0,0-1.686-1.686H283.876v3.56a2.7,2.7,0,0,1,0,5.377Z"
                transform="translate(-282.544 0)"
                fill="#2c2750"
              />
            </g>
          </g>
        </g>
        <g
          id="Group_10876"
          data-name="Group 10876"
          transform="translate(8.25 5.966)"
        >
          <g id="Group_10872" data-name="Group 10872" transform="translate(0)">
            <path
              id="Path_2183"
              data-name="Path 2183"
              d="M35.715,106.73a.666.666,0,0,0,.666-.666v-2.411a.666.666,0,0,0-.666-.666h-4.57a.666.666,0,0,0-.655.786l.1.538a1.369,1.369,0,0,1-1.325,1.615,1.329,1.329,0,0,1-1.045-.482,1.419,1.419,0,0,1-.314-1.175l.091-.5a.666.666,0,0,0-.655-.786H22.981V99.857a2.7,2.7,0,0,0,0-5.377V90.254a.666.666,0,0,0-.666-.666H11.268A3.021,3.021,0,0,0,8.25,92.606v22.1a3.021,3.021,0,0,0,3.018,3.018h22.1a3.021,3.021,0,0,0,3.018-3.018v-1.933a.666.666,0,1,0-1.332,0V114.7a1.688,1.688,0,0,1-1.686,1.686H22.981v-4.3a.666.666,0,0,0-.786-.655l-.04.007a1.369,1.369,0,1,1,0-2.693l.04.007a.666.666,0,0,0,.786-.655v-3.784h3.575A2.745,2.745,0,0,0,27.2,106.3a2.692,2.692,0,0,0,4.731-1.986h3.116v1.745A.666.666,0,0,0,35.715,106.73ZM9.582,92.606a1.688,1.688,0,0,1,1.686-1.686H21.649v4.254a.666.666,0,0,0,.786.655l.04-.007h0a1.369,1.369,0,1,1,0,2.693l-.04-.007a.666.666,0,0,0-.786.655v3.825H18.792a2.7,2.7,0,0,0-5.189,0H9.582Zm10.6,15.417a2.7,2.7,0,0,0,1.469,4.763v3.6H11.268A1.688,1.688,0,0,1,9.582,114.7V104.319h4.582a.666.666,0,0,0,.665-.637,1.369,1.369,0,0,1,2.736,0,.666.666,0,0,0,.665.637h3.419v3.089a2.693,2.693,0,0,0-1.469.614Z"
              transform="translate(-8.25 -89.588)"
              fill="#2c2750"
            />
          </g>
          <g
            id="Group_10875"
            data-name="Group 10875"
            transform="translate(26.8 19.13)"
          >
            <g id="Group_10874" data-name="Group 10874">
              <g id="Group_10873" data-name="Group 10873">
                <path
                  id="Path_2184"
                  data-name="Path 2184"
                  d="M411.343,378.171a.666.666,0,1,1,.653-.535.671.671,0,0,1-.653.535Z"
                  transform="translate(-410.678 -376.841)"
                  fill="#2c2750"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
